<template>
    <v-card>
        <v-card-text>
            <item-selector v-model="selection" v-bind="{
                loading,
                disabled,
                action,
                label,
                multiple: false,
                extraParams,
                itemText,
                itemValue,
                queryParameter,
                returnObject: true,
            }" @search="v => search = v"
            outlined />

            <v-data-table v-bind="{
                items: value,
                headers,
                loading,
                //search: search,
            }">
                <template v-slot:item.actions="{ item }">
                    <v-btn icon color="error" @click="deleteItem(item)"><v-icon>delete</v-icon></v-btn>
                </template>
            </v-data-table>
        </v-card-text>
        <input v-if="name" type="hidden" v-for="(e, index) in value" v-bind="{
            name: `${name}[]`,
            value: e[itemValue],
        }" :key="index" />
    </v-card>
</template>

<script>
export default {
    props: {
        value: { type: Array, },
        action: { required: true },
        name: {},
        loading: { default: false },
        disabled: { default: false },
        queryParameter: { default: 's' },
        label: { default: '' },
        itemText: { default: 'value' },
        itemValue: { default: 'value' },
        extraParams: { default: () => ({}) },
    },
    data() {
        return {
            selection: '',
            search: '',

            headers: [
                { text: this.label, value: this.itemText, sortable: true, filterable: true, },
                { text: '', value: 'actions', sortable: false, filterable: false, },
            ]
        }
    },
    methods: {
        deleteItem(item) {
            let index = this.value.findIndex(e => e[this.itemValue] == item[this.itemValue]);
            if (index >= 0)
                this.value.splice(index, 1);
        }
    },
    watch: {
        selection(v) {
            this.$nextTick(() => this.selection = null);
            if (v) {
                //only if not exists
                let duplicateExists = this.value.filter(e => e[this.itemValue] == v[this.itemValue]).length > 0;
                if (duplicateExists)
                    return;
                this.value.push(this.selection);
            }
        }
    }

}
</script>
